import { TLoadable, createUnloaded, createLoading, createLoadErrored, createLoaded, isLoaded } from "../../../../sg-core";
import { IPersonAction } from "../actions/personAction";
import IPerson from '../../interfaces/IPerson';
import { itemsToMappedIdList, appendUniqueToLodableIdList } from '../../utils/item.helpers'

export const defaultPersonState: IPersonState = {
    persons: {},
    personList: createUnloaded(),
    personListWithProcessorRole: createUnloaded(),

};

export interface IPersonState {
    persons: { [key: string]: TLoadable<IPerson> }
    personList: TLoadable<number[]>;
    personListWithProcessorRole: TLoadable<number[]>;
}

export default function PersonReducer(state = defaultPersonState, action: IPersonAction) {
    switch (action.type) {

        case "REQUEST_FETCH_PERSONS": {
            const mappedLoading = action.payload.personIds.reduce<{ [key: string]: TLoadable<IPerson> }>((acc, id) => {
                return (!state.persons[id] || !isLoaded(state.persons[id])) ? { ...acc, [id]: createLoading() } : acc
            }, {})

            return {
                ...state,
                persons: { ...state.persons, ...mappedLoading },
                personList: createLoading(),
            };
        }

        case "SUCCESS_FETCH_PERSONS": {
            const parsed = itemsToMappedIdList(action.payload.persons);
            const loadedList = parsed.ids.reduce((acc, id) => ({ ...acc, [id]: createLoaded(parsed.mapping[id]) }), {})
            return {
                ...state,
                persons: { ...state.persons, ...loadedList },
                personList: appendUniqueToLodableIdList(state.personList, parsed.ids),
            };
        }

        case "FAILURE_FETCH_PERSONS": {
            const erroredPersons = action.payload.personIds.reduce((acc, id) => ({ ...acc, [id]: createLoadErrored(action.payload.error) }), {})
            return {
                ...state,
                persons: { ...state.persons, ...erroredPersons },
                personList: createLoadErrored(action.payload.error),
            };
        }

        case "APPEND_TO_PERSON_LIST": {
            const parsed = itemsToMappedIdList(action.payload.persons);
            const loadedList = parsed.ids.reduce((acc, id) => ({ ...acc, [id]: createLoaded(parsed.mapping[id]) }), {})
            return {
                ...state,
                persons: { ...state.persons, ...loadedList },
                personList: appendUniqueToLodableIdList(state.personList, parsed.ids),
            };
        }


        case "REQUEST_FETCH_PERSONS_BY_PROCESSOR_ROLE": {
            return {
                ...state,
                personListWithProcessorRole: createLoading(),
            };
        }
        case "SUCCESS_FETCH_PERSONS_BY_PROCESSOR_ROLE": {
            const parsed = itemsToMappedIdList(action.payload.persons);
            const loadedList = parsed.ids.reduce((acc, id) => ({ ...acc, [id]: createLoaded(parsed.mapping[id]) }), {})
            return {
                ...state,
                persons: { ...state.persons, ...loadedList },
                personListWithProcessorRole: createLoaded(parsed.ids),
            };
        }
        case "FAILURE_FETCH_PERSONS_BY_PROCESSOR_ROLE": {
            return {
                ...state,
                personListWithProcessorRole: createLoadErrored(action.payload.error),
            };
        }


        default: {
            return state;
        }
    }
}